<sbnb-connect-airbnb-unofficial-phase1
  *ngIf="stage === 1"
  [login]="login"
  (phaseComplete)="startOauthFlow()"></sbnb-connect-airbnb-unofficial-phase1>
